import { ChangeDetectionStrategy, Component } from '@angular/core';
import { ToggleModule } from '@df/ui/toggle/toggle.module';
import { MEGANAV_GROUP_ID } from '../page/header/page-header.component';
@Component({
    selector: 'meganav-overlay',
    templateUrl: 'meganav-overlay.html',
    standalone: true,
    imports: [ToggleModule],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class MeganavOverlayComponent {
    readonly meganavToggleGroupId = MEGANAV_GROUP_ID;
}
